import { render } from "./glassitem-sharebuttons.vue?vue&type=template&id=0886b232"
import script from "./glassitem-sharebuttons.vue?vue&type=script&lang=js"
export * from "./glassitem-sharebuttons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__